import request from '@/plugins/axios'

//获取标签列表
export function list(params) {
  return request({
    url: '/labelClass/list',
    method: 'get',
    params
  })
}

//添加标签
export function addClass(data) {
  return request({
    url: '/labelClass/addClass',
    method: 'post',
    data
  })
}

//删除标签
export function deleteClass(params) {
  return request({
    url: '/labelClass/deleteClass/' + params,
    method: 'get'
  })
}

//查询单个标签
export function getClass(params) {
  return request({
    url: '/labelClass/getClass/' + params,
    method: 'get'
  })
}
